(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('okan-ring-design')) {
  customElements.define('okan-ring-design', class extends HTMLElement {
    connectedCallback() {
      if(this.dataset.approvedRing === 'true') return;
      this.scope = this.closest('.shopify-section');
      if (!this.scope) return;
      this.openDrawer = '';
      this.abort = new AbortController();
      this.observer = new MutationObserver(() => this.sync());
      this.scope.addEventListener('change', () => queueMicrotask(() => this.sync()), {signal:this.abort.signal});
      this.sync();
    }
    openMetalInfo() {
      if (this.metalDialog?.open) return;
      const dialog=this.querySelector('[data-ring-metal-dialog]')?.content.querySelector('dialog')?.cloneNode(true);
      if (!dialog) return;
      this.metalDialog=dialog;document.body.append(dialog);
      dialog.querySelector('.okan-ring-metal-close').onclick=()=>dialog.close();
      dialog.querySelector('.okan-ring-metal-return').onclick=()=>dialog.close();
      dialog.addEventListener('close',()=>{dialog.remove();if(this.metalDialog===dialog)this.metalDialog=null;if(this.isConnected)this.metalUI?.querySelector('.okan-ring-metal-discover')?.focus({preventScroll:true});},{once:true});
      dialog.showModal();
    }
    getPicker() {
      return [...this.scope.querySelectorAll('variant-picker')].find(p => p.dataset.productId === this.dataset.productId && !p.closest('product-card,quick-add-dialog'));
    }
    getMetals() {
      return [...(this.getPicker()?.querySelectorAll(`input[type=radio][data-input-id^="${this.dataset.metalPosition}-"]`) || [])];
    }
    cleanup() {
      this.metalDialog?.close();this.metalDialog?.remove();
      this.metalUI?.remove(); this.sizeUI?.remove();
      this.metalUI = this.sizeUI = null;
      this.getPicker()?.removeAttribute('data-okan-loading');
      this.scope?.querySelectorAll('.okan-ring-design-native-metal,.okan-ring-design-native-price,.okan-ring-design-folded,.okan-ring-design-active').forEach(n=>n.classList.remove('okan-ring-design-native-metal','okan-ring-design-native-price','okan-ring-design-folded','okan-ring-design-active'));
    }
    sync() {
      this.observer.disconnect();
      try {
        const picker = this.getPicker(), metals = this.getMetals();
        const choice = picker?.querySelector('.okan-ring-choice');
        const price = picker?.querySelector('[data-okan-color-price]');
        const amount = price?.querySelector('.okan-selected-color-price__amount');
        // Enhance only a fully supported picker, otherwise retain the original UI.
        if ((!choice && this.dataset.noSize !== 'true') || !metals.length || !amount) { picker?.removeAttribute('data-okan-loading'); this.cleanup(); return; }
        picker.classList.add('okan-ring-design-active');
        if (!this.metalUI?.isConnected) {
          this.metalUI = this.querySelector('[data-metal]').content.firstElementChild.cloneNode(true);
          (choice?.parentElement || picker.querySelector('.variant-picker__form')).prepend(this.metalUI);
          this.metalUI.querySelector('.okan-ring-metal-discover')?.addEventListener('click',()=>this.openMetalInfo());
          this.metalUI.querySelector('button').onclick = () => { this.openDrawer = this.openDrawer === 'metal' ? '' : 'metal'; this.sync(); };
          const panel = this.metalUI.querySelector('.okan-ring-design-options');
          panel.id = 'okan-ring-metals-' + this.dataset.productId;
          this.metalUI.querySelector('button').setAttribute('aria-controls',panel.id);
        }
        if (choice && this.dataset.noSize !== 'true') {
        if (!this.sizeUI?.isConnected) {
          this.sizeUI = this.querySelector('[data-size]').content.firstElementChild.cloneNode(true);
          choice.before(this.sizeUI);
          this.sizeUI.querySelector('button').onclick = () => { this.openDrawer = this.openDrawer === 'size' ? '' : 'size'; this.sync(); };
        }
        if (!choice.id) choice.id = 'okan-ring-sizes-' + this.dataset.productId;
        this.sizeUI.querySelector('button').setAttribute('aria-controls',choice.id);
        this.sizeUI.querySelector('button').setAttribute('aria-expanded',String(this.openDrawer === 'size'));
        choice.classList.toggle('okan-ring-design-folded',this.openDrawer !== 'size');
        const selectedSize = choice.querySelector('input:checked');
        const summary = this.sizeUI.querySelector('.okan-ring-design-size-summary');
        const summaryText = choice.dataset.mode === 'kit' ? this.dataset.kitLabel : selectedSize ? (selectedSize.closest('.okan-ring-choice__custom') ? selectedSize.closest('label').querySelector('.variant-option__button-label__text').textContent.trim() : this.dataset.sizeLabel + ' ' + selectedSize.value) : this.dataset.selectSizeLabel;
        if(summary.textContent !== summaryText) summary.textContent = summaryText;
        summary.hidden = this.openDrawer === 'size';
        }
        const singleMetal = metals.length === 1;
        if (singleMetal && this.openDrawer === 'metal') this.openDrawer = '';
        const metalToggle = this.metalUI.querySelector('.okan-ring-design-toggle');
        metalToggle.disabled = singleMetal;
        this.metalUI.classList.toggle('has-single-metal', singleMetal);
        metalToggle.style.cursor = singleMetal ? 'default' : '';
        metalToggle.querySelector('.okan-ring-design-chevron').hidden = singleMetal;
        metalToggle.querySelector('.okan-ring-design-chevron').style.display = singleMetal ? 'none' : '';
        if (singleMetal) {
          metalToggle.removeAttribute('aria-expanded');
          metalToggle.removeAttribute('aria-controls');
        } else {
          metalToggle.setAttribute('aria-expanded', String(this.openDrawer === 'metal'));
          metalToggle.setAttribute('aria-controls', 'okan-ring-metals-' + this.dataset.productId);
        }
        this.metalUI.classList.toggle('is-open', !singleMetal && this.openDrawer === 'metal');
        metals.forEach(i=>i.closest('fieldset')?.classList.add('okan-ring-design-native-metal'));
        price.classList.add('okan-ring-design-native-price');
        // Copy the server-rendered price including any compare-at price; no price estimates.
        const output = this.metalUI.querySelector('.okan-ring-design-price');
        if (output.innerHTML !== amount.innerHTML) output.innerHTML = amount.innerHTML;
        const panel = this.metalUI.querySelector('.okan-ring-design-options');
        let variants=[];
        try { variants=JSON.parse(picker.querySelector('[data-ring-variant-prices]')?.content.textContent || '[]'); } catch {}
        const chosen=[...picker.querySelectorAll('input[type=radio]:checked')];
        const optionPrice=input=>{
          const match=variants.find(v=>v.options[Number(this.dataset.metalPosition)-1]===input.value && chosen.every(c=>{
            const pos=Number(c.dataset.inputId?.split('-')[0]);
            return !pos || pos===Number(this.dataset.metalPosition) || v.options[pos-1]===c.value;
          }));
          return match?.price || (input.checked ? amount.textContent.trim() : this.dataset.unavailableLabel);
        };
        const signature = JSON.stringify([chosen.map(i=>i.value),variants,metals.map(i=>[i.value,i.checked,i.disabled,i.dataset.optionAvailable])]);
        if(panel.dataset.signature !== signature) {
          const focused = panel.contains(document.activeElement) ? document.activeElement.dataset.value : null;
          panel.dataset.signature = signature;
          panel.replaceChildren();
          metals.forEach(input=>{
            const button = document.createElement('button');
            button.type='button'; button.className='okan-ring-design-option'; button.dataset.value=input.value;
            if (singleMetal) { button.style.cursor='default'; button.disabled=true; }
            button.disabled=singleMetal || input.disabled; button.setAttribute('aria-pressed',String(input.checked));
            button.dataset.unavailable=String(input.dataset.optionAvailable==='false');
            const dot=document.createElement('span');dot.className='okan-ring-design-swatch';dot.dataset.silver=String(/argent|silver/i.test(input.value));dot.setAttribute('aria-hidden','true');
            const label=document.createElement('span');label.className='okan-ring-design-option-text';label.textContent=input.value;
            if(/or|gold|argent|silver/i.test(input.value)) button.append(dot);
            button.append(label);
            const optionAmount=document.createElement('span');
            optionAmount.className='okan-ring-design-option-price';optionAmount.textContent=optionPrice(input);
            button.append(optionAmount);
            button.onclick=()=>{
              if(this.getMetals().length === 1) return;
              if(this.openDrawer!=='metal'){this.openDrawer='metal';this.sync();return;}
              const native=this.getMetals().find(i=>i.value===input.value);
              if(native && !native.disabled){native.click();this.sync();}
            };
            panel.append(button);
          });
          if(focused) [...panel.children].find(b=>b.dataset.value===focused)?.focus({preventScroll:true});
        }
        picker.removeAttribute('data-okan-loading');
      } finally {
        if(this.isConnected) this.observer.observe(this.scope,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['checked','disabled','data-option-available','data-mode']});
      }
    }
    disconnectedCallback(){if(this.dataset.approvedRing === 'true') return;this.abort?.abort();this.observer?.disconnect();this.cleanup();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
